import './src/styles/uikit.css';
import './src/styles/global.css';
